var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCamera(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_252",
    "data-name": "Group 252",
    transform: "translate(-0.333 0.312)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_119",
    "data-name": "Group 119",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_601",
    "data-name": "Rectangle 601",
    transform: "translate(5.333 -0.312)",
    fill: "#fff",
    stroke: "#7e8080",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 6,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 12,
    height: 4,
    rx: 1,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_600",
    "data-name": "Rectangle 600",
    transform: "translate(0.333 2.688)",
    fill: "#fff",
    stroke: "#7e8080",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 19,
    rx: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 22,
    height: 17,
    rx: 2,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_50",
    "data-name": "Ellipse 50",
    transform: "translate(5.333 5.688)",
    fill: "#fff",
    stroke: "#7e8080",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 7,
    cy: 6.5,
    rx: 7,
    ry: 6.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7,
    cy: 6.5,
    rx: 6,
    ry: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_51",
    "data-name": "Ellipse 51",
    transform: "translate(9.333 8.688)",
    fill: "#fff",
    stroke: "#7e8080",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 3,
    cy: 3.5,
    rx: 3,
    ry: 3.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3,
    cy: 3.5,
    rx: 2,
    ry: 2.5,
    fill: "none"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.5a4e0553.svg";
export { ForwardRef as ReactComponent };